import axiosInstant from "../../../../api";
import { uploadRequestEndpoint } from "../../../../api/endpoints";
import { IVideo } from "../hooks/useFetchVideos";
import { putToS3WithProgress } from "./putToS3";

// The API builds the iconik key (brand / project / channel folder and the
// next slot version) from the file row and stamps the upload with the
// environment, so the pipeline imports it back into this API. The signed
// headers it returns must go on the PUT verbatim.
export const uploadVideoToIconik = async (
    file: File,
    video: IVideo,
    onProgress?: (pct: number) => void,
): Promise<void> => {
    if (!video.id) {
        throw new Error("Video has no id; cannot upload");
    }

    const { data } = await axiosInstant.post(uploadRequestEndpoint(), {
        purpose: "final_video",
        fileId: video.id,
    });

    await putToS3WithProgress(data.signedRequest, file, "video/mp4", {
        onProgress,
        headers: data.headers,
    });
};
